import { useEffect, useRef } from 'react'

export function Cursor() {
  const dotRef = useRef<HTMLDivElement>(null)
  const ringRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (window.matchMedia('(pointer: coarse)').matches) return

    let x = -100
    let y = -100
    let ringX = -100
    let ringY = -100
    let raf = 0

    const move = (event: PointerEvent) => {
      x = event.clientX
      y = event.clientY
      dotRef.current?.style.setProperty('transform', `translate3d(${x}px, ${y}px, 0)`)
    }
    const hover = (event: Event) => {
      const target = event.target as HTMLElement
      ringRef.current?.classList.toggle('is-hovering', Boolean(target.closest('a, button, [data-cursor]')))
    }
    const render = () => {
      ringX += (x - ringX) * 0.13
      ringY += (y - ringY) * 0.13
      ringRef.current?.style.setProperty('transform', `translate3d(${ringX}px, ${ringY}px, 0)`)
      raf = requestAnimationFrame(render)
    }

    window.addEventListener('pointermove', move)
    document.addEventListener('pointerover', hover)
    raf = requestAnimationFrame(render)
    return () => {
      window.removeEventListener('pointermove', move)
      document.removeEventListener('pointerover', hover)
      cancelAnimationFrame(raf)
    }
  }, [])

  return (
    <div className="cursor-layer" aria-hidden="true">
      <div className="cursor-dot" ref={dotRef} />
      <div className="cursor-ring" ref={ringRef} />
    </div>
  )
}
